import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import { Link } from "react-router-dom";

// Current Route-> /subscriptions-models/current-subscribed

const CurrentSubscribePackage = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            className="object-contain"
            alt="hamburger"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="flex justify-between items-center mt-8 ml-4 w-[95%]">
        <p className="text-[18px] ">Current Subscription Packages</p>
        <p className="underline text-[#2F80ED] text-[18px] cursor-pointer">
          View all Packages
        </p>
      </div>

      {/* First Plan */}
      <div className=" flex justify-center items-center ml-4 mt-16">
        <div className="relative w-[55%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ">
          <p className="text-[18px] text-[#333333] font-bold mt-5 mb-4 text-center">
            Organizer Pro
          </p>
          <p className="absolute top-2 right-3 text-[12px] text-[#828282] italic">
            order iD- 13E4347RY
          </p>
          <p className="items-center font-bold text-[12px] w-[70%] justify-start  text-center">
            01st Jan 2024
          </p>
          <p className="items-center text-[#828282] text-[12px] mt-2 w-[70%] justify-start  text-center">
            Subscription ends in 20 days
          </p>
          <p className="items-center text-[#828282] text-[16px] mt-4 w-[70%] justify-start text-center">
            Event organizers in need of comprehensive post-exhibition solutions
            for multiple exhibitors.
          </p>
          <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 mt-5 py-1 text-black text-center">
            $500
            <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
          </div>

          <div className="flex justify-center w-full mt-6 mb-4 text-white">
            <button className=" w-[30%] py-2 rounded-lg bg-[#2f81ed7e] text-[14px] ">
              Renew
            </button>
          </div>
          <p className="items-center text-[#828282] text-[16px] mb-4 w-[70%] justify-start text-center">
            Renewal date 20th mARCH 2025
          </p>
        </div>
      </div>

      <div className="flex justify-center mt-10 mb-4">
        <Link
          to="/subscriptions-models/cancellation"
          className="underline text-[#2F80ED] text-[18px] cursor-pointer"
        >
          Cancel Subscription
        </Link>
      </div>
    </div>
  );
};

export default CurrentSubscribePackage;
